var _g, _path, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProdCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2916_19468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3226 21.218L26.9385 12.181C26.0737 8.90305 23.9093 7.43325 21.0634 8.18505L11.4248 10.7312C8.53228 11.4954 7.41223 13.8328 8.277 17.1107L10.6611 26.1477C11.5399 29.4785 13.6527 30.9043 16.5452 30.1401L26.1839 27.5939C29.0297 26.8421 30.2013 24.5488 29.3226 21.218Z",
    fill: "#FFB47F"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2616 9.82422H20.5702C15.5808 9.82422 12.7539 12.6511 12.7539 17.6404V31.3188C12.7539 36.3081 15.5808 39.135 20.5702 39.135H34.2616C39.251 39.135 42.0647 36.3081 42.0647 31.3188V17.6404C42.0647 12.6511 39.251 9.82422 34.2616 9.82422Z",
    fill: "#FEE1D0",
    stroke: "url(#paint0_linear_2916_19468)",
    strokeWidth: 0.732769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51684 7.15679L22.7693 3.61206C27.5988 2.32031 31.0555 4.32296 32.3494 9.1434L32.5381 9.84637H20.5718C15.5725 9.84637 12.74 12.6739 12.74 17.6644V31.3459C12.74 33.1291 13.1017 34.6362 13.7947 35.8367C10.7047 35.6046 8.49919 33.5747 7.5255 29.9473L3.97823 16.732C2.68431 11.9116 4.68745 8.44857 9.51684 7.15679Z",
    fill: "url(#paint1_linear_2916_19468)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2916_19468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4731 9.82422H20.5545C15.5751 9.82422 12.7539 12.6518 12.7539 17.6424V31.3241C12.7539 33.1074 13.1142 34.6145 13.8044 35.8151C14.8166 35.8915 15.9241 35.7733 17.1146 35.4536L30.3143 31.9088C35.1244 30.617 37.107 27.1573 35.8183 22.3368L32.4731 9.82422Z",
    fill: "url(#paint2_linear_2916_19468)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9517 16.0527C27.2522 16.0527 26.6762 16.6085 26.6762 17.2966V32.4085C26.6762 33.0834 27.2522 33.6392 27.9517 33.6392C28.6648 33.6392 29.2408 33.0834 29.2408 32.4085V17.2966C29.2408 16.6085 28.6648 16.0527 27.9517 16.0527ZM20.9903 20.8157C20.2909 20.8157 19.7148 21.3607 19.7148 22.0355V32.066C19.7148 32.7278 20.2909 33.2728 20.9903 33.2728C21.7035 33.2728 22.2795 32.7278 22.2795 32.066V22.0355C22.2795 21.3607 21.7035 20.8157 20.9903 20.8157ZM33.2711 27.5593C33.2711 26.869 33.8471 26.3115 34.5603 26.3115C35.2597 26.3115 35.8358 26.869 35.8358 27.5593V32.4046C35.8358 33.0817 35.2597 33.6392 34.5465 33.6392C33.8471 33.6392 33.2711 33.0817 33.2711 32.4046V27.5593Z",
    fill: "url(#paint3_linear_2916_19468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2916_19468",
    x: 0.664495,
    y: 0.664495,
    width: 36.2726,
    height: 37.005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66385,
    result: "effect1_foregroundBlur_2916_19468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2916_19468",
    x: 6.89175,
    y: 3.96206,
    width: 35.1735,
    height: 37.738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93108,
    result: "effect1_foregroundBlur_2916_19468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2916_19468",
    x1: 2943.83,
    y1: 9.82422,
    x2: 12.7539,
    y2: 2940.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2916_19468",
    x1: 1615.28,
    y1: 3.22871,
    x2: 1615.28,
    y2: 3634.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2916_19468",
    x1: 1325.45,
    y1: 1484.69,
    x2: -474.681,
    y2: 2277.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2916_19468",
    x1: -201.424,
    y1: 1308.21,
    x2: 529.986,
    y2: 2809.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF5602",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdCategory);
export default __webpack_public_path__ + "static/media/ProdCategory.42b8e697b37a87cc8689e9149f1fb031.svg";
export { ForwardRef as ReactComponent };